import React from 'react';

/**
 * The surname, drawn by CSS rather than markup — see `.surname` in styles/main.css.
 *
 * The letters are not in the DOM, so they are not in the HTML a crawler receives and
 * not in the text a page-scraper extracts. It inherits the surrounding font, size and
 * colour like any other text, and screen readers announce CSS-generated content, so
 * the name still reads normally out loud.
 *
 * Two things it is not: copy-pasteable, and findable with ⌘F.
 */
const Surname = () => <span className="surname" />;

export default Surname;
